import React from 'react';
import { usePortalAuth } from '../../context/PortalAuthContext';
import { PORTAL_OVERVIEW } from '../../constants/testIds';

const STATUS_STYLES = {
  pending: 'bg-amber-100 text-amber-700',
  active: 'bg-emerald-100 text-emerald-700',
  paused: 'bg-stone-200 text-stone-600',
};

const PortalOverview = () => {
  const { user } = usePortalAuth();
  const client = user?.client;

  return (
    <div data-testid={PORTAL_OVERVIEW.page}>
      <h1 className="text-2xl font-extrabold text-stone-900 mb-1">Welcome{client ? `, ${client.business_name}` : ''}</h1>
      <p className="text-stone-500 text-sm mb-7">Your Ambanji account overview.</p>

      {!client ? (
        <div data-testid={PORTAL_OVERVIEW.notLinkedState} className="bg-white border border-dashed border-stone-300 rounded-2xl p-10 text-center max-w-lg">
          <p className="text-stone-700 font-semibold mb-2">Your account isn't linked yet</p>
          <p className="text-stone-500 text-sm">
            We haven't set up your Ambanji subscription yet. If you've already subscribed, reach out to us
            and we'll get you linked. Otherwise, contact us to get started.
          </p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-stone-200 p-6 max-w-lg">
          <div className="flex items-center justify-between mb-4">
            <p className="text-sm text-stone-500">Plan</p>
            <p data-testid={PORTAL_OVERVIEW.planName} className="font-bold text-stone-900">{client.package_name}</p>
          </div>
          <div className="flex items-center justify-between">
            <p className="text-sm text-stone-500">Status</p>
            <span data-testid={PORTAL_OVERVIEW.statusBadge} className={`text-xs font-semibold rounded-full px-2.5 py-1 ${STATUS_STYLES[client.status] || ''}`}>
              {client.status}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PortalOverview;
